<template>
    <div class="flex-row header-container">
        <div class="flex-row">
            <div class="flex-align-center folder" @click="collapseMenu">
                <md-icon class="md-icon-s-fold" name="fold"></md-icon>
            </div>
            <md-menu
                type="whiteBackground"
                class="md-menu-container"
                :default-active="activeIndex"
                mode="horizontal"
                active-text-color="#0077FF"
                text-color="#212B36"
                background-color="transparent"
                @select="handleSelect">
                <md-menu-item v-for="item in system" :key="item.fdId" :index="item.fdKey" :name="item.fdKey">{{ item.fdName }}</md-menu-item>
            </md-menu>
        </div>
        <div class="flex-row">
            <div class="flex-align-center header-right">
                <ul class="right-list">
                    <!-- 供应商名称 -->
                    <li><span>{{supplierInfoGetter.vendorName || vendorName}}</span></li>
                    <li><User /></li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import User from '@/components/core/themes/default/components/User.vue';
import { systemMark, intSystems, intHostName } from '@/utils/tool';

export default {
    name: 'Header',
    components: {
        User,
    },
    computed: {
        ...mapGetters(['supplierInfoGetter']),
        system() {
            const { authority } = this.$store.state;
            return authority;
        },
        activeIndex() {
            return systemMark();
        },
        vendorName() {
            return JSON.parse(localStorage.getItem('supplierInfo'))?.vendorName;
        },
    },
    methods: {
        handleSelect(key) {
            const { origin } = window.location;
            const systemLink = {
                gsc_new: '/gn/gsc.html',
                GSCNEW: '/gn/gsc.html',
                globalSuppliers: '/gscierp.html',
                globalprotal: '/int/globalprotal.html',
                gsc: '/gn-o/gsc.html',
                gsceu: '/int/globalprotal.html',
                gscus: '/int/globalprotal.html',
            };
            if (intSystems.includes(key)) {
                if (key !== systemMark()) {
                    window.location.href = `${origin.replace(/gschk|gsceu|gscus|gsc/g, intHostName(key))}${systemLink[key]}`;
                }
            } else {
                window.location.href = `${origin.replace(/gschk|gsc-hk|gsceu|gsc-eu|gscus|gsc-us/g, 'gsc')}${systemLink[key]}`;
            }
        },
        collapseMenu() {
            this.$emit('handleCollapse');
        },
    },
};

</script>
<style lang='less' scoped>
@import url("../../../../styles/vars.less");
.header-container{
  justify-content: space-between;
}
.folder{
  padding-right: 20px;
  cursor: pointer;
  .md-icon-fold{
    font-size: 16px;
  }
}
.md-menu-container.md-menu {
  /deep/.md-menu-item{
    height: @header-height;
    line-height: @header-height;
    padding: 0;
    margin-right: 16px;
    &:hover{
      background-color: #E7F2FF;
    }
  }
}
.header-right{
  height: @header-height;
  justify-content: space-between;
  color: #919EAB;
  .right-list{
    display: flex;
    align-items: center;
    li, .pd-r-16{
      display: flex;
      align-items: center;
    }
    li{
      padding-left: 16px;
      cursor: pointer;
    }
  }
  .right-extra{
    .user-id{
      padding: 0 4px;
    }
    .user-img{
      height: 20px;
      border-radius: 50%;
    }
  }
  /deep/.md-popover__reference-wrapper{
    display: flex;
    align-items: center;
  }
  .md-badge {
    cursor: pointer;
    /deep/.md-badge__content{
      font-size: 10px;
      height: 16px;
      line-height: 14px;
      padding: 0 4px;
    }
  }
}
.tip-download{
    display: flex;
    align-items: center;
    img{
        padding-right: 4px;
    }
}
</style>